module.exports = __webpack_public_path__ + "img/video_icon_with_circle.c8f752ba.svg";